module.exports = __webpack_public_path__ + "static/media/control-vs-acceptance-large@3x.989288d9.png";